module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapimage"
  }, [_c('a', {
    attrs: {
      "id": "chapter01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/chapimage.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Once upon a time, in the Forested Land")]), _vm._v(", a merchant named Laurent Marchand lived with his second wife, Celestine, and their little daughter, Rose. Laurent toiled endlessly to acquire vast wealth, and Fortune smiled on him. His family lived like nobility in a sprawling slate-roofed "), _c('em', [_vm._v("château")]), _vm._v(" that towered above fertile orchards and wild woods teeming with game. They dressed in fine silks and satins and dined on dishes of gold bound with silver. Their servants were happy and counted themselves lucky indeed to work for such a prosperous man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But as with all forested lands, shadows cast their darkness over the manor on the hill. That was to be expected. Most living things begin in the absence of light: The vine is rooted in the earth; the fawn takes form in the womb of the doe. So it is with secret wounds and heartaches. They can father the greatest happiness—if a brave, shining soul will bear them from the darkness and lift them to the light.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("So it is also with the deepest of all joys: a love so true and everlasting that it can heal such wounds. For ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("true love is true magic, as those who have found it can attest.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Laurent’s dark, secret wound was named Reginer Marchand. Reginer was Laurent’s son by his first wife, who had died giving birth to him. Laurent pinned all his hopes on his heir, waiting for the day when his son would be old enough to help him expand his vast domain. He believed that with Reginer by his side, he would amass a fortune larger than any he could create alone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Reginer wanted to be a painter, not a merchant. He spent days, nights, weeks at his easel, reveling in his artistic vision. Thanks to Laurent’s efforts, the family would never run out of money, so why sacrifice his dream on the altar of commerce?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Laurent was infuriated by his son’s “disloyalty.” Painting was a fine pastime, but there was an estate to manage and trading to do. Anger grew on both sides, and one stormy January night, Laurent and Reginer quarreled violently. Reginer packed a bag and stomped out of the grand house. Biting sleet pierced his ermine cloak, and the winter wind wailed like mourners at a funeral.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Go! Go and be damned!” Laurent yelled, shaking his fist at his son’s retreating back. “Though you starve, though your children beg in the streets, never ask a thing of me! Think of me as your father no longer and never dare to put your hand on my door!”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Heartsick and humiliated, Reginer obeyed his ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("father’s command to the letter. Years passed, and he did not return.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("When Laurent married his second wife, Celestine, and brought her to the estate, she was sorry to learn of the rift between her new husband and his firstborn. Despite her gentle entreaties, Laurent still refused to forgive Reginer. And as Celestine loved her husband and owed him everything, she promised that she would follow his edict and bar the door to her stepson. But Reginer never came. So the shadow of the wound became invisible, although it was still very real.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The other shadow that fell across the lives of the Marchands was easier to see, although it too, had to do with the aching of the human heart. It was Laurent’s near-continuous absence from the beautiful "), _c('em', [_vm._v("château")]), _vm._v(" and his family.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I chase gold as others chase the hare,” he boasted to his delicate, fair-haired wife, “and I do so for you and our daughter. My love is such that you will never go wanting.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("He didn’t understand that Celestine and Rose were sorely wanting indeed: When he was gone, which was more often than not, they missed him terribly. His time and attention were more valuable to them by far than their jewels and dresses. Of a moonlit evening, Celestine would walk along the stony terraces of the "), _c('em', [_vm._v("château")]), _vm._v(", gazing past the topiary garden, the hedge maze, and the chestnut groves to the narrow, winding mountain passes, searching for ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("her husband’s retinue. She understood that Laurent loved them, but there were times she felt more widow than wife.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Aside from her beloved child, Celestine’s boon companion was Elise Lune, who had served as Celestine’s nurse at the family seat on the Emerald Plains. When Celestine married Laurent, the young bride begged Elise to come with her to the Forested Land.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I shall know no one there,” Celestine reminded her. “And one hopes that one will have children, and such tiny blossoms will need tending. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Elise had no other family and loved Celestine like her own child. So she left the comfort of the Emerald Plains to journey with her young mistress to the Forested Land. She was the first to know that Celestine would have a child and she helped in the delivery of Rose. Many a night she walked the floors of the Marchand mansion, singing lullabies and bouncing the teething child. She was with Celestine when Rose took her first step. And it was she who slipped Celestine’s gold coins bearing the likeness of King Henri beneath Rose’s pillow whenever the dear girl lost a tooth. She was so beloved that she became "), _c('em', [_vm._v("Tante")]), _vm._v(" Elise—Aunt Elise—and the fact that she was a servant slipped from everyone’s minds.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("When little Rose turned seven, Celestine decided to create a rose garden for her daughter’s pleasure. Once the dozens of bushes were planted, Celestine tended them with nearly as much love and devotion ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("as she showered on "), _c('em', [_vm._v("la belle")]), _vm._v(" Rose. The roses responded and the garden became an astonishing bower of unearthly beauty, a lush, velvet canopy of crimson hanging over a blanket of scarlet, opulent with heady perfume. Celestine placed two stone statues of young does at the entrance to the grotto and erected a life-size marble statue of the goddess Artemis in the center. Strong, serene Artemis was the Goddess of the Hunt and of the Moon, and Celestine was devoted to her. Artemis watched over women everywhere and offered them protection when and where she could.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Seeking such protection for Rose, Celestine surrounded Artemis with white roses, symbols of her child’s innocence and purity. She added a trickling fountain and silvery stream, inviting the wild deer that roamed the manor grounds to drink and rest. And on each lonely night of her vigil for Laurent, she would kneel at the feet of her patroness and pray for his safe return.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The path to the statue grew worn as the years passed. The white rosebushes—indeed, all the rosebushes—flourished into a magical land of their own. Laurent came and went, as was his custom. Mother and daughter were cherished, but usually from afar. Rose became a beautiful girl, an unusual girl, with silvery-gold hair that shimmered like the coin her father pursued, and starry eyes of midnight blue.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("On the evening before Rose’s thirteenth birthday, the crescent moon shone against the winter sky like Artemis’s gleaming bow. The air quivered with ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("anticipation. Laurent had sent dozens of gifts—a music box, a harp, and a tender portrait of a young girl with a white cat—but the most exquisite gift of all was a formal gown of deep rose-colored satin and gold tissue, embroidered with silver stars. Celestine had never seen such a magnificent dress in her entire life, and as she fingered the layers and layers of fabric, she couldn’t wait to see Laurent’s face when he saw his daughter wearing it. Such attention to detail, such care, assured Celestine that the giver of the gift—Laurent—knew that this dress was meant for someone’s Best Beloved—that he loved their child with all his heart.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("But she felt a soft pity for him, as well. Celestine knew that as wonderful as the dress and all the other presents might be, the only thing Rose wanted for her birthday was her father. And this, Celestine suspected, he did not know. He counted his worth in the things he could give them, and not in himself, their beloved husband and father. He would probably be most amazed to know that Rose had been counting the days until her birthday not so she could have her gifts, but in the hopes that he would put his arms around her and hold her close.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Indeed, her sweet daughter had embroidered a fine purple cloak for him, to thank him for the gift of life. Rose had stitched thirteen roses on the border, leaving room for more years to come. It lay among the gifts he had sent to her and she couldn’t wait to give it to him.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Sunset after sunset Rose stood on the watchtower, waiting for him. He didn’t come. As the evening became night and then midnight on the eve of her birthday, there was no still sign of him.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Celestine was determined not to let the terrible disappointment mar the dawn. “I call on you, my patroness,” she murmured as she scattered dried white rose petals before the marble statue. It was the beginning of winter, and the hands of all the bushes, including the white ones, had been trimmed back. Their fingertips were painted with frost. “Goddess,” she prayed, “give Rose a gift as she enters the sisterhood of women. Send Laurent home for her birthday.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The crescent moon rippled, and a spray of shooting stars cascaded like a falling arrow over the craggy mountaintops.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A night breeze sighed against Celestine’s ear as if to say, "), _c('em', [_vm._v("“I cannot force the actions of another.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Alas,” Celestine murmured as the last of the petals drifted from her fingertips. “Then, at least, please let her know her father loves her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“I cannot guarantee the heart of another,”")]), _vm._v(" the breeze replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('em', [_vm._v("My")]), _vm._v(" heart is guaranteed,” she pledged. “Let her know "), _c('em', [_vm._v("my")]), _vm._v(" heart. Let her know that she is loved with a love that is true and will never fade as the rose petal fades. If she knows that, it will be all that she needs in this life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“That is your request? Is that the gift she will have for her birthday?”")]), _vm._v(" asked the breeze.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('em', [_vm._v("“Oui,”")]), _vm._v(" Celestine replied.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“You desire this for your daughter beyond riches?”")]), _vm._v(" asked the breeze. "), _c('em', [_vm._v("“Is it better to know that you are loved or to live in plenty?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s better to know that you are loved.” Celestine answered. Who knew the answer to that question better than she? “A woman who is loved is the richest woman on earth.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As she spoke, a dappled fawn cautiously entered the rose grotto, gazed at her with its large brown eyes, and hesitantly approached the stream. Celestine stood motionless, so as not to frighten the sweet little creature.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fawn lowered its head and lapped at the water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“And what of safety? Is it better to know that you are loved or to know that you are safe?”")]), _vm._v(" the breeze challenged her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s better to know that you are loved,” Celestine whispered, watching the deer. “There’s no greater harbor than that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“What if death takes the one who loves you? Then love is gone and you have nothing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“True love never dies,” she insisted. “It lives beyond the grave, in the heart of the beloved.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“That is what you wish your daughter to know?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oui,” she said again. “Then she’ll be rich and safe for all her days.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("The moonlight shifted above her, casting her in a shower of light. The luxurious scent of roses wafted around her, although there were no blossoms on the ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("branches. She gazed up at the moon and then back where the fawn had been drinking.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The creature had turned snow-white and it was glowing like the moon itself. As it lifted its head and gazed at her, she saw that its eyes were dark blue, like Rose’s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“You have the wisdom of Athena and the heart of Demeter,”")]), _vm._v(" the breeze declared. "), _c('em', [_vm._v("“Best Beloved, it shall be as you wish.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Something tugged hard at her heart, stealing a beat from it. Her lips parted as she pressed her hand against her chest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Where the shimmering fawn had stood, a luminous being appeared, shining from crown to heel as if it too, were made of moonbeams. A silver bow was slung over its left shoulder, along with a quiver of arrows made of light. Perhaps it was Eros, God of Love.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Celestine shielded her eyes; the figure was so bright that she could hardly look at it. She felt another tug on her heart and she lost another beat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“Fear not. It is done,”")]), _vm._v(" said the luminous figure. "), _c('em', [_vm._v("“Go and fetch your child. Bring her here. Leave her nurse asleep. Quickly, before the dawn, or your wish will not come true.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The being raised its right arm and pointed toward the topmost turret of the "), _c('em', [_vm._v("château")]), _vm._v(", where Rose slept. Beyond the circular roof, the hem of the sky was growing light.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Celestine dropped a curtsy. Then she turned and skirted the silvery stream, racing past the double ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("statues of deer at the grotto’s entrance. At last she dashed into the "), _c('em', [_vm._v("château")]), _vm._v(", startling the night watch. She raced to her daughter’s pink-and-white chamber and opened the door.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Her breath caught at the sight of her child, asleep in her canopy bed of creamy satin hangings embroidered with roses. The first hint of morning filtered through the stained glass windows, brushing Rose’s petal-soft skin with feathery kisses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“Bonjour")]), _vm._v(", Rose,” Celestine murmured, rousing her daughter ever so gently. “It is your birthday, my love. The happiest day of my life. Come to the garden and receive your special gift.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“Maman?”")]), _vm._v(" Rose said drowsily as she opened her deep blue eyes. They widened; hope danced in them. “Is Papa here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not quite yet.” She held her close.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rose’s lower lip trembled and she looked away to hide a tear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The day is young,” Celestine said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“Oui, Maman,”")]), _vm._v(" Rose replied, but the tear sparkled like a diamond.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Come with me.” Celestine reached for Rose’s ermine cloak and fleece-lined leather slippers. “There is magic in the air.” She helped Rose out of bed and wrapped her in the warm cloak and slippers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Magic? What magic?” Rose asked.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("“Birthday magic,” her mother answered, leading her out of her room. “Let’s wake up Tante Elise.” She rapped softly on the nurse’s door. The snoring ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("continued. Celestine knew they must hurry and she wished she’d thought to awaken Elise first. She decided to let her sleep, mindful of the beings command to bring Rose to the garden before the dawn.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ll come back for her in a little while,” Celestine said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like naughty children, they tiptoed through the sleeping household, down the circular staircase, moving so fast that Celestine felt dizzy and almost missed a step.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Snow sprinkled their bare heads as they ran breathlessly out the door, past the topiary figures dusted with snowflakes: a dragon, a gryphon, a lion. A lark trilled. A wind whipped up, sweeping the snow from their path as they tripped through the hedge maze. They turned left and left again, leaving the grandeur of the "), _c('em', [_vm._v("château")]), _vm._v(" behind, to enter the wintry simplicity of the bare rose garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They froze in their tracks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is this?” Celestine whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All the bushes had burst into full bloom. The grotto was a trove of color. Fiery curtains of orange and crimson petals pooled on top of the snowbanks. Pinks dotted the overhanging clusters of billowy yellow. Ivory blossoms piqued the snow like rosettes on a wedding gown.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“Maman")]), _vm._v(", it’s so beautiful!” Rose whirled in a circle, her ermine cloak making a disc of white around her. Damascene moonlight and sunshine glowed against her eager face. “What a gift! "), _c('em', [_vm._v("Merci, Maman!”")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Celestine gazed this way and that, searching for the luminous being. But neither it nor the shimmering fawn was anywhere to be seen.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("How can this be?")]), _vm._v(" Celestine silently asked the statue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As if in answer, tears welled in the statue’s eyes. Tears? On a joyful occasion such as this? Frightened, Celestine felt her heart tug again, much harder this time. She lost three beats at once.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The tears spilled from the marble eyes onto a spray of white roses, and they immediately turned a subtle shade of blue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“Maman")]), _vm._v(", look!” Rose cried. Unaware of her mother’s confusion and of the weeping statue, she picked one of the blue roses and held it out to Celestine. But as Celestine reached for it, her chest seized again and her hand jerked. She pricked her finger on the blue rose’s thorn, and three droplets of blood fell onto the azure petals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A rich, deep purple spread through the petals like blood through veins.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are wounded!” Rose cried as she dropped the flower. It fell onto the bush. The color seeped from that blossom to the next, and to the next, until all the roses on the bush were the same vibrant shade.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And in that moment, Celestine knew that she was dying. Her wish had set her death in motion, and her request was to be her last.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Rose,” Celestine said urgently as she sank against the soft pillows of snow, “listen to me.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("“What is happening? What’s wrong?” Rose demanded, dropping to her knees beside her. “I’ll go for help!”")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. Stay. Listen,” Celestine ordered her. Her words came with difficulty as she gasped for breath. “The purple roses. They’re your birthday gift. They’re my promise that you are loved with real, true love. Remember that. Love is real and it is the greatest gift, and it is yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you saying?” Rose asked shrilly as Celestine’s eyes flickered and the light began to leave them. She threw back her head and cried to the last traces of the night, “Help! Tante Elise! "), _c('em', [_vm._v("Au secours!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('em', [_vm._v("Attends")]), _vm._v(". Listen,” her mother whispered. She gripped Rose hard, with the desperation of one who is putting to sea on the barge of the dead, yet has unfinished business in the land of the living. “No matter your griefs or your sorrows, your trials or your fate, always remember: "), _c('em', [_vm._v("Ma belle, ma petite")]), _vm._v(", you are loved.” She began to weep as Rose’s image grew fainter and more distant. “Never forget. You are loved.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“Maman!”")]), _vm._v(" Rose screamed, understanding at last that her mother was dying. “Don’t leave me!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You will always have my love,” Celestine gasped. “Always.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rose burst into tears, leaning over her mother, embracing her, kissing her, willing her to stay in the mortal world. She rocked her and begged her and wept for what seemed like years.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("The deer statues at the entrance to the garden lowered their heads. The goddess sighed. As the blazing chariot of Apollo galloped on the horizon, Celestine Marchand breathed her last.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The roses in the bower immediately withered and died—all save the purple rosebush. Golden sunshine gilded the magic petals, and they whispered to the distraught girl:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“You are loved")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“You are loved")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“You are loved.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b87e6e88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter01.vue
// module id = 75
// module chunks = 0